var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 512 512",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m256 418.9 16.5 16.5L419 288.9l36.9 36.9-130 130-53.4-53.4zl16.5 16.5zl-16.5 16.5 69.8 69.8c4.3 4.3 10.3 6.8 16.5 6.8 6.1 0 12.1-2.5 16.5-6.8l162.9-162.9c4.3-4.3 6.8-10.3 6.8-16.5 0-6.1-2.5-12.1-6.8-16.5l-69.8-69.8c-9.1-9.1-23.8-9.1-32.9 0l-163 163c-4.3 4.3-6.8 10.3-6.8 16.5 0 6.1 2.5 12.1 6.8 16.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m395.6 279.3 22.8-4.6-34.9-174.5c-1.8-8.9-8.6-15.9-17.4-18.1L28.7.6c-7.8-1.8-16.2.5-21.9 6.2S-1.3 20.9.6 28.7l81.5 337.5c2.1 8.8 9.2 15.6 18.1 17.4l174.5 34.9c7.6 1.5 15.5-.9 21-6.4l116.4-116.4c5.5-5.5 7.9-13.4 6.4-21zl-16.5-16.5-107.5 107.6-147.8-29.6-69-286 286 69 32 160zl-16.5-16.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6.8 39.7 176.5 176.5c9.1 9.1 23.8 9.1 32.9 0s9.1-23.8 0-32.9L39.7 6.8c-9.1-9.1-23.8-9.1-32.9 0s-9.1 23.8 0 32.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M232.7 186.2v23.3c12.8 0 23.2 10.4 23.3 23.3 0 12.8-10.4 23.2-23.3 23.3-12.8 0-23.2-10.4-23.3-23.3 0-12.8 10.4-23.3 23.3-23.3zv-23.3c-38.6 0-69.8 31.2-69.8 69.8s31.2 69.8 69.8 69.8 69.8-31.2 69.8-69.8-31.2-69.8-69.8-69.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.1428d2f34b6b9188eb4965ce80f2c975.svg";
export { ForwardRef as ReactComponent };